<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 22/9/2020
  -->

<template>
	<FormRow
        v-if="!readonly || valueData"
		:prop="prop"
		:title="title"
		:tooltipText="tooltipText"
		:tooltip-position="tooltipPosition"
		:isFocused="isFocusedData"
		:content-class="readonly ? '' : 'white-smoke mb-3'"
		:readonly="readonly"
		:showHighlight="showHighlight"
		:disabled="disabled"
		v-bind="$attrs"
		>

<!--		<div >-->

		<div v-if="readonly"
			 v-html="valueData"
			 style="line-height: normal"
			 class="preserve-new-lines"
			 />
		<EditorView v-model="valueData"
                    v-else
					ref="editorView"
					:placeholder="placeholder"
					:analytics-props="analyticsPropsMethod()"
					v-bind="attrsNoListeners"
					@blur="onBlur"
					@change="notifyValueChanged"/>
	</FormRow>
</template>

<script>
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import EditorView from "@/core/modules/Notes/view/EditorView.vue";
import BaseFormRow from "@/core/components/Form/Base/BaseFormRow.vue";
export default {
	name: "FormEditorRow",
	components: {EditorView, FormRow},
	extends: BaseFormRow,
	inheritAttrs: false,

	props: {
		showHighlight: Boolean,
		tooltipPosition: String,
		inputDebounceDelay: {Number, default: 1000},
	},


	methods: {
		//WARNING don't do this. below replaceAll("\n", "<br/>") breaks data consistency and while it may display correctly, the internal "\n" still there and if no changes are made to the content it will lead to inconsistent presentation upstream.
		// formatDataIn(data){
		// 	if(data){
		// 		return data.replaceAll("\n", "<br/>")
		// 	}
		// 	return data
		// },
		getCursorPosition() {
			let res = 0
			if(this.$refs.editorView){
				res = this.$refs.editorView.getCursorPosition()
			}
			return res
		},

		insertTextAtCursor(text){
			if(this.$refs.editorView){
				this.$refs.editorView.insertTextAtCursor(text)
			}
		}
	},
}
</script>

<style>

</style>
